import { render, staticRenderFns } from "./avis_user.vue?vue&type=template&id=654a09c2"
import script from "./avis_user.vue?vue&type=script&lang=js"
export * from "./avis_user.vue?vue&type=script&lang=js"
import style0 from "./avis_user.vue?vue&type=style&index=0&id=654a09c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports